<button *ngFor="let profile of profiles" mat-menu-item class="lang-hld" (click)="selectProfile(profile)">
  <div>
    <mat-icon svgIcon="{{ profile.profile.language }}" class="app-icon-hover flag-icon"></mat-icon>
    <span class="profile-name" [ngClass]="{ 'active-profile': profile.isCurrent }">{{ profile.profile.name }}</span>
  </div>
  <mat-icon [svgIcon]="profile.isCurrent ? 'radio_checked' : 'radio_unchecked'" class="app-icon-hover check-icon">
  </mat-icon>
</button>
